import React from 'react';

export default () => (
  <div className="gp-content1 gp-form-explinations">
    <p>
      Vous avez repéré un message abusif ?
      Signalez-le nous par e-mail, avec l'objet "Modération",
      en nous donnant le prénom, nom (si il est affiché),
      ainsi que le message, à <a className="bluelink" href="https://laffairedusiecle.net/contact/">contact@laffairedusiecle.net</a>.
    </p>
  </div>
);
